import * as actionType from "../ActionTypes";
import * as mutationType from "../MutationType";
import api from "../../config/api";
const state = {
    faq:false,
};
const getters = {
    faq: (state) => state.faq
};

const actions = {
    
    [actionType.CREATE_FAVOURITES_USER]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.post(`/favourites/listing/${params.listing_id}`).then(result => {
                resolve(result)
            })
            .catch(error => reject(error));
        });
    },
    [actionType.DELETE_FAVOURITES_USER]: async function ({ commit }, params) {
        return new Promise((resolve, reject) => {
            api.delete(`/favourites/listing/${params.id}`).then(result => {
                resolve(result);
                dispatch('UserListingController/IS_DELETE_LISTING',false,{root:true});
            })
            .catch(error => reject(error));
        });
    },
    "GET_FAQ": async function ({ commit },data) {
        commit("SET_FAQ",data )
    }
};

const mutations = {
    
    "SET_FAQ": function (state,data) {
        state.faq = data;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}